import { ArrowBack } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material'
import Image from 'next/image'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export interface Props {
  email: string
  onBackClicked: () => void
}

export const LoginMagicLinkContainer = ({ email, onBackClicked }: Props) => {
  const { t } = useTranslation('login')
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Stack spacing={0}>
        <Stack direction="row" style={{ paddingTop: 11, paddingBottom: 39 }}>
          <IconButton aria-label="back" onClick={onBackClicked}>
            <ArrowBack sx={{ color: 'neutralLight.900' }} width={16} height={16} />
          </IconButton>
        </Stack>
        <Stack spacing={2} alignItems="center">
          <Image src="/app/assets/email.svg" alt="email sent" height={140} width={215} />
          <Typography style={{ paddingTop: 30 }} suppressHydrationWarning variant="H5Semibold">
            {t('magic-link.title')}
          </Typography>
          <Trans
            i18nKey="login:magic-link.subtitle"
            components={{
              p: <Typography textAlign="center" variant="Body14pxRegular" color="neutralLight.900" />,
              b: <b />,
            }}
            values={{ email }}
          />
          <Link underline="hover" color="#7B61FF" onClick={handleClickOpen}>
            <Typography suppressHydrationWarning variant="Body14pxRegular">
              {t('magic-link.link')}
            </Typography>
          </Link>
        </Stack>
      </Stack>
      <Dialog sx={{ zIndex: 9999 }} open={open} onClose={handleClose}>
        <DialogTitle>{t('magic-link.dialog.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans
              i18nKey="login:magic-link.dialog.body"
              components={{
                ul: <List sx={{ listStyleType: 'disc', pl: 6 }} />,
                li: (
                  <ListItem
                    sx={{
                      display: 'list-item',
                      padding: '0',
                    }}
                  />
                ),
                lit: (
                  <ListItemText
                    slotProps={{
                      primary: { suppressHydrationWarning: true },
                    }}
                  />
                ),
                b: <b />,
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="secondary" variant="contained" suppressHydrationWarning>
            {t('magic-link.dialog.close-button')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
